import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { scan } from "react-scan";
import "@/config/i18n.config";
import App from "./App.tsx";
import { initLogger } from "./config/logger.config.ts";

if (typeof window !== "undefined" && import.meta.env.VITE_DEBUG === "true") {
  console.info("🔍: Perfmormance monitoring enabled");
  scan({
    enabled: true,
  });
}

initLogger();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
